/* eslint-disable */
// @ts-nocheck
// This file provide additional compatibility functions,
// to do best effort to match previous behavior
// with a previous version of react-select (v1)

/**
 * Provide compatible clearable state between and react-select v1 and
 * later versions.
 *
 * @param props react-select props from v1.
 */
export function getClearable(props: { clearable?: boolean; creatable?: boolean }): boolean | null | undefined {
  if (!props.creatable) {
    return props.clearable;
  }

  if (props.clearable === undefined || props.clearable === null) {
    // react-select version 1, provided default clearable state to true
    // for creatable selects.
    // we are going to maintain that behavior for now, as part of compatilibty.
    return true;
  }

  return props.clearable;
}
